import {BehaviorSubject, Subject} from 'rxjs';
import {filter, map, tap} from 'rxjs/operators';
import type {Subscription, Observable} from 'rxjs';
import {SPOT_TRADE_MODE} from './enum';

interface SpotModeDataMap<T> {
  [SPOT_TRADE_MODE.Margin]: Subject<T>;
  [SPOT_TRADE_MODE.Spot]: Subject<T>;
}

export function createSpotModeState$<T>(mode$: Observable<SpotTradeMode>, dataObs: SpotModeDataMap<T>, targetDefault: T): [BehaviorSubject<T>, Subject<T>] {
  const sub$ = new BehaviorSubject<Subscription>(null);
  const read$ = new BehaviorSubject<T>(targetDefault);
  const update$ = new Subject<T>();
  const updateSub$ = new BehaviorSubject<Subscription>(null);
  mode$
    .pipe(
      filter((mode) => Object.hasOwnProperty.call(dataObs, mode)),
      map((mode) => dataObs[mode]),
      tap(() => {
        const sub = sub$.getValue();
        if (sub) {
          sub.unsubscribe();
        }
        const updateSub = updateSub$.getValue();
        if (updateSub) {
          updateSub.unsubscribe();
        }
      })
    )
    .subscribe((targetOb) => {
      read$.next(targetDefault);

      const sub = targetOb.subscribe((o) => read$.next(o));
      const updateSub = update$.subscribe((o) => targetOb.next(o));
      sub$.next(sub);
      updateSub$.next(updateSub);
    });

  return [read$, update$];
}
